
import { jsPDF } from "jspdf";
import autoTable from 'jspdf-autotable';

const ConstruirMinuta = async (datos, firmaPersona, infoMinuta) => {
    const pdf = new jsPDF('p', 'pt', [600, 500], { compress: true });
    const data = {
        titulo1: (infoMinuta.find(x => x.str_nombrecampo === 'titulo1') || {}).str_descripcion || "FALTA CONFIGURACION TITULO MINUTA",
        contratos: (infoMinuta.find(x => x.str_nombrecampo === 'contratos') || {}).str_descripcion || "FALTA CONFIGURACION CONTRATOS MINUTA",
        acepto: (infoMinuta.find(x => x.str_nombrecampo === 'acepto') || {}).str_descripcion || "FALTA ACEPTACION MINUTA",
    };
    if(datos){
        pdf.setFontSize(8).setFont("helvetica", 'bold');
        const pageWidth = pdf.internal.pageSize.getWidth();
        const textWidth = pdf.getTextWidth(data.titulo1);
        const textX = (pageWidth - textWidth) / 2;
        pdf.text(data.titulo1, textX, 20);
        pdf.setFontSize(7).setFont("helvetica", 'normal');
        pdf.text([data.contratos], pageWidth / 2, 35, {
            maxWidth: 450,
            align: 'center'
        });
        pdf.setFontSize(7).setFont("helvetica", 'normal');
        pdf.text(data.acepto, 25, 59);
        pdf.setFontSize(6).setFont("helvetica", 'normal');
        let y = 70; // Initial Y position after the title
        const lines = [
            "• Los productos recibidos son de primera calidad con auditoria permanente de la Unidad de Seguridad Alimentaria – Secretaría de Inclusión Social y Familia.",
            "• El valor de los productos se asignan según la tipología del núcleo familias así: A, B, C y D.",
            "• Los productos cumplen con requisitos de seguridad, fechas de vencimiento y certificados de salud.",
            "• Los productos han sido empacados de acuerdo a la minuta establecida para un periodo de un mes.",
            "• No recibiré apoyo económico adicional para el empaque o traslado de los productos recibidos.",
            "• La firma del acta conforma el recibido por parte del (los/las) beneficiarios(as) de las siguientes minutas:",
        ];
        
        for (const line of lines) {
            pdf.text(line, 25, y, {maxWidth: 450, align: 'justify'});
            y += 10; // Adjust line spacing as needed
        }

        const alimentosTableHead = [
            ["GRUPO DE ALIMENTOS", "ALIMENTOS", "UNIDAD DE MEDIDA", "CANTIDAD POR PAQUETE"]
        ];

        const alimentosTableBody = [
            ["Productos azucarados", "Panela en bloque", "Mínimo 900 grs", "1"],
            ["Bebidas", "Cocoa en polvo", "Paquete mínimo 250 grs", "1"],
            ["Pescados y Mariscos", "Atún en aceite", "Latas de 170 grs o superior", "4"],
            ["Huevos y derivados", "Huevo tipo A", "Unidad tipo A", "30"],
            ["Cereales y Derivados", "Arroz blanco tipo 1 fortificado", "Libra", "6"],
            ["Cereales y Derivados", "Harina para arepas", "Libra", "1"],
            ["Cereales y Derivados", "Galletas tipo soda", "Paquete 300 grs", "1"],
            ["Cereales y Derivados", "Pasta menuda para sopa", "Paquete 250 grs", "1"],
            ["Cereales y Derivados", "Espaguetis", "Paquete 250 grs", "1"],
            ["Cereales y Derivados", "Avena en hojuelas", "Paquete 250 grs", "1"],
            ["Grasas y Aceites", "Aceite vegetal", "Litro (1.000cc)", "1"],
            ["Leches y Derivados", "Leche entera en Polvo", "Bolsa desde 380 grs o superior", "1"],
            ["Leguminosas y Derivados", "Frijol cargamento de primera", "Libra", "3"],
            ["Leguminosas y Derivados", "Lenteja", "Libra", "1"],
            ["Leguminosas y Derivados", "Garbanzo", "Libra", "1"],
            ["Misceláneos", "Sal con Yodo", "Libra", "1"]
        ];

        autoTable(pdf, {
            startY: y + 10, // Start after last text line
            head: alimentosTableHead,
            body: alimentosTableBody,
            margin: { left: 25, right: 25 },
            theme: "grid",
            styles: {
                fontSize: 6,
                cellPadding: 2,
                halign: 'center',
                valign: 'middle'
            },
            headStyles: {
                fillColor: [220, 220, 220],
                textColor: [0, 0, 0],
                fontStyle: 'bold'
            }
        });

        const kitHabitatTableHead = [
            ["PRODUCTO (KIT HABITAT)", "TIPO A", "TIPO B", "TIPO C", "TIPO D", "MEDIDA"]
        ];

        const kitHabitatTableBody = [
            ["Colchoneta", "1", "2", "3", "5", "Unid"],
            ["Cobija", "1", "2", "3", "5", "Unid"],
            ["Almohada", "1", "2", "3", "5", "Unid"],
            ["Toalla", "1", "2", "3", "5", "Unid"],
            ["Sábana", "1", "2", "3", "5", "Unid"]
        ];

        autoTable(pdf, {
            startY: pdf.lastAutoTable.finalY + 2, // Start after previous table
            head: kitHabitatTableHead,
            body: kitHabitatTableBody,
            margin: { left: 25, right: 25 },
            theme: "grid",
            styles: {
                fontSize: 6,
                cellPadding: 2,
                halign: 'center',
                valign: 'middle'
            },
            headStyles: {
                fillColor: [220, 220, 220],
                textColor: [0, 0, 0],
                fontStyle: 'bold'
            }
        });

        const kitCocinaTableHead = [
            ["PRODUCTO (KIT COCINA)", "TIPO A", "TIPO B", "TIPO C", "TIPO D", "MEDIDA"]
        ];

        const kitCocinaTableBody = [
            ["Chocolatera", "1", "1", "1", "2", "Unid"],
            ["Olla #24", "1", "1", "1", "2", "Unid"],
            ["Cucharon", "1", "1", "1", "2", "Unid"],
            ["Plato hondo", "1", "2", "3", "5", "Unid"],
            ["Cuchara de mesa", "1", "2", "3", "5", "Unid"],
            ["Taza", "1", "2", "3", "5", "Unid"],
            ["Cuchillo de mesa", "1", "2", "3", "5", "Unid"],
            ["Molino", "1", "1", "1", "1", "Unid"]
        ];

        autoTable(pdf, {
            startY: pdf.lastAutoTable.finalY + 2, // Start after previous table
            head: kitCocinaTableHead,
            body: kitCocinaTableBody,
            margin: { left: 25, right: 25 },
            theme: "grid",
            styles: {
                fontSize: 6,
                cellPadding: 2,
                halign: 'center',
                valign: 'middle'
            },
            headStyles: {
                fillColor: [220, 220, 220],
                textColor: [0, 0, 0],
                fontStyle: 'bold'
            }
        });

        const kitAseoTableHead = [
            ["PRODUCTO (KIT ASEO)", "TIPO A", "TIPO B", "TIPO C", "TIPO D", "MEDIDA"]
        ];

        const kitAseoTableBody = [
            ["Papel higiénico", "2", "3", "4", "5", "Unid"],
            ["Máquina de afeitar", "1", "1", "1", "1", "Unid"],
            ["Jabón de baño", "1", "2", "3", "4", "125 Gr"],
            ["Jabón de panela", "1", "1", "1", "1", "250 Gr"],
            ["Jabón en polvo", "1", "1", "1", "1", "250 Gr"],
            ["Cepillo de dientes", "1", "1", "1", "1", "Unid"],
            ["Crema dental", "1", "1", "1", "1", "90 Gr"],
            ["Paquete de toallas higiénicas", "1", "1", "1", "1", "Pqte"],
            ["Jabón de panela (doble propósito)", "1", "1", "1", "1", "250 Gr"],
            ["Jabón en polvo (doble propósito)", "1", "1", "1", "1", "250 Gr"],
            ["Estropajo", "1", "1", "1", "1", "Unid"],
            ["Plástica lava loza en polvo", "1", "1", "1", "1", "250 Gr"],
            ["Cepillo de uñas", "1", "1", "1", "1", "Unid"],
            ["Detergente en polvo", "1", "2", "5", "7", "250 Gr"]
        ];

        autoTable(pdf, {
            startY: pdf.lastAutoTable.finalY + 2, // Start after previous table
            head: kitAseoTableHead,
            body: kitAseoTableBody,
            margin: { left: 25, right: 25 },
            theme: "grid",
            styles: {
                fontSize: 6,
                cellPadding: 2,
                halign: 'center',
                valign: 'middle'
            },
            headStyles: {
                fillColor: [220, 220, 220],
                textColor: [0, 0, 0],
                fontStyle: 'bold'
            }
        });
        y = pdf.lastAutoTable.finalY + 10;
        pdf.setFontSize(6).setFont("helvetica", 'normal');
        const linesOpciones = [
            "( ) Recibo a satisfacción la asistencia humanitaria compuesta por el paquete alimentario y/o kits después de revisar los paquetes.",
            "(X) Recibo a satisfacción la asistencia humanitaria compuesta por el paquete alimentario y/o kits sin revisar los paquetes.",
            "( ) No recibo la asistencia humanitaria compuesta por el paquete alimentario y/o kits.",
        ];

        for (const line of linesOpciones) {
            pdf.text(line, 25, y, {maxWidth: 450, align: 'justify'});
            y += 10; // Adjust line spacing as needed
        }

        // Add signature section after linesOpciones
        let PositionTables = y + 10;
        pdf.text("RECIBE ", 25, PositionTables);
        PositionTables = PositionTables + 5;
        let dataFirma = [[`C.C. Nro. ${datos.datosMinuta[0].idpersona ?? ''}`, "Huella índice derecho"]];
        autoTable(pdf, {
            startY: PositionTables,
            tableWidth: 270,
            margin: { left: 25, bottom: 25 },
            tableLineColor: [0, 0, 0],
            tableLineWidth: 0.75,
            theme: "plain",
            columnStyles: {
                0: { valign: 'bottom', halign: 'left', cellWidth: 210, minCellHeight: 50, lineWidth: 0.5, lineColor: [0, 0, 0], fontSize: 8, cellPadding: 1 },
                1: { valign: 'bottom', halign: 'center', cellWidth: 60, minCellHeight: 50, lineWidth: 0.5, lineColor: [0, 0, 0], fontSize: 5, cellPadding: 1 }
            },
            body: dataFirma,
        });
        if (firmaPersona) {
            pdf.addImage(firmaPersona, 'PNG', 40, PositionTables + 5, 150, 35);
        }
    }
    const pdfBlob  = pdf.output('blob');
    const fileURL = URL.createObjectURL(pdfBlob); 
    return fileURL;
};

export default ConstruirMinuta;